export default {
    common: {
        appName: 'Swift Invoice',
        cancel: 'Batal',
        email: 'E-mel',
        password: 'Kata laluan',
        or: 'atau',
        change: 'Tukar',
        delete: 'Padam',
        save: 'Simpan',
        edit: 'Sunting',
        add: 'Tambah',
        close: 'Tutup',
        date: 'Tarikh',
        total: 'Jumlah',
        status: 'Status',
        amount: 'Jumlah',
        quantity: 'Kuantiti',
        rate: 'Kadar',
        tax: 'Cukai',
        discount: 'Diskaun',
        note: 'Nota',
        notes: 'Nota',
        description: 'Penerangan',
        client: 'Pelanggan',
        item: 'Item',
        items: 'Item',
        type: 'Jenis',
        category: 'Kategori',
        phone: 'Telefon',
        name: 'Nama',
        subject: 'Subjek',
        saveAndClose: 'Simpan dan Tutup',
        saveAndSendEmail: 'Simpan dan Hantar E-mel',
        sendEmail: 'Hantar e-mel',
        send: 'Hantar',
        print: 'Cetak',
        moreActions: 'Tindakan lain',
        preparingPdf: 'Menyediakan PDF...',
        pdfPreparationFailed: 'PDF tidak dapat disediakan',
        warning: 'Amaran',
        ok: 'OK',
        uploadSuccess: 'muat naik berjaya',
        saveSuccess: 'simpan berjaya',
        deleteSuccess: 'padam berjaya',
        deleteFailed: 'padam gagal',
        saveFailed: 'simpan gagal',
        loadFailed: 'muat gagal',
        systemError: 'ralat sistem',
        sendSuccess: 'hantar berjaya',
        updateSuccess: 'kemaskini berjaya',
        unsavedChangesMsg: 'Anda mempunyai perubahan yang belum disimpan. Adakah anda ingin menyimpan atau membuangnya?',
        saveChangesTitle: 'Simpan perubahan?',
        confirmSave: 'Simpan',
        discard: 'Buang',
        validEmail: 'Sila masukkan alamat e-mel yang sah',
        deleteFailedMsg: 'padam gagal',
        shipping: 'Penghantaran',
        attachment: 'Lampiran',
        days: 'Hari',
        excl: '(tidak termasuk)',
        incl: '(termasuk)',
        of: 'daripada'
    },
    login: {
        heroPrefix: 'Pintar ',
        heroInvoising: 'Penginvoisan',
        heroMiddle: ',',
        heroSimplified: 'Dipermudahkan',
        heroSuffix: ' untuk Anda.',
        subtitle1: 'Cipta, hantar, dan urus invois dengan mudah.',
        subtitle2: 'Dapatkan bayaran lebih pantas dengan Swift Invoice.',
        feature1Title: 'Invois Profesional',
        feature1Text: 'Cipta invois yang menarik dalam beberapa minit',
        feature2Title: 'Penjejakan Masa Nyata',
        feature2Text: 'Jejak pembayaran dan status invois',
        feature3Title: 'Selamat & Boleh Dipercayai',
        feature3Text: 'Data anda selamat dengan keselamatan tahap perusahaan',
        welcomeBack: 'Selamat kembali',
        signInToContinue: 'Log masuk ke akaun anda untuk teruskan',
        enterEmail: 'Masukkan e-mel anda',
        enterPassword: 'Masukkan kata laluan anda',
        rememberMe: 'Ingat saya',
        forgotPassword: 'Lupa kata laluan?',
        signIn: 'Log masuk',
        signingIn: 'Sedang log masuk…',
        continueWithGoogle: 'Teruskan dengan Google',
        continueWithApple: 'Teruskan dengan Apple',
        createAccount: 'Cipta akaun',
        startUsing: 'Mula guna Swift Invoice',
        companyName: 'Nama syarikat',
        enterCompanyName: 'Masukkan nama syarikat anda',
        alreadyHaveAccount: 'Sudah ada akaun? Log masuk',
        footerRights: '© 2026 Swift Invoice. Hak cipta terpelihara.',
        termsOfService: 'Terma Perkhidmatan',
        contactUs: 'Hubungi kami: goodinvoicego@gmail.com',
        betaDialogBody: 'Pasukan kami telah menyiapkan versi pertama web <br> Versi ini hanya tersedia untuk pengguna iPhone <br> Kami akan menambah baik fungsi web secepat mungkin dan membukanya kepada semua <br>',
        ieDialogBody: 'Maaf, disebabkan pelayar IE mempunyai masalah keserasian, kami tidak menyokong pelayar IE buat masa ini, jika anda perlu menggunakannya, sila muat turun',
        resetPasswordTitle: 'Set semula kata laluan',
        sendResetEmail: 'Hantar e-mel set semula',
        resetEmailSent: 'E-mel set semula kata laluan telah dihantar. Sila semak kotak masuk anda.',
        bindingTitle: 'Pautkan akaun sedia ada',
        bindingHintPrefix: 'Akaun sudah menggunakan e-mel ',
        bindingHintSuffix: '. Masukkan kata laluan akaun tersebut untuk memautkan log masuk Google anda.',
        enterAccountPassword: 'Masukkan kata laluan akaun',
        linkAccount: 'Pautkan akaun',
        validEmail: 'Sila masukkan alamat e-mel yang sah',
        validPassword: 'Kata laluan mesti 6 aksara atau lebih',
        validCompanyName: 'Sila isi nama syarikat anda'
    },
    account: {
        title: 'Akaun',
        profile: 'Profil',
        swiftAccount: 'Akaun Swift Invoice',
        connectSocial: 'Sambung akaun sosial',
        companyLogo: 'Logo syarikat',
        addLogo: 'Tambah logo',
        uploading: 'sedang memuat naik...',
        currentPlan: 'Pelan semasa: Swift {plan}',
        planActiveUntil: 'Pelan aktif sehingga {date}',
        sharedWithMobile: 'Dikongsi dengan telefon bimbit',
        subscriptionExpired: 'Langganan anda telah tamat',
        planNote: 'Log masuk semula jika status langganan anda belum dikemas kini.',
        upgradeToPro: 'Naik taraf ke Swift Pro',
        viewPlans: 'Lihat pelan langganan',
        connecting: 'Menyambung…',
        connectGoogle: 'Sambung Google',
        googleConnected: 'Google disambung',
        googleConnectedWithEmail: 'Google disambung ({email})',
        connectApple: 'Sambung Apple',
        appleConnected: 'Apple disambung',
        appleConnectedWithEmail: 'Apple disambung ({email})',
        logoUuidMissing: 'UUID logo syarikat hilang',
        googleConnectedToast: 'Akaun Google disambung.',
        appleConnectedToast: 'Akaun Apple disambung.'
    },
    menu: {
        invoices: 'Invois',
        estimates: 'Anggaran',
        purchaseOrders: 'Pesanan Pembelian',
        items: 'Item',
        clients: 'Pelanggan',
        expenses: 'Perbelanjaan',
        reports: 'Laporan',
        settings: 'Tetapan',
        companyInfo: 'Maklumat syarikat',
        taxes: 'Cukai',
        default: 'Lalai',
        customizeInvoice: 'Sesuaikan invois',
        sendFeedback: 'Hantar Maklum Balas',
        newReply: '1 balasan baharu',
        signOut: 'Log keluar',
        signOutConfirm: 'Adakah anda pasti untuk log keluar?',
        addBusiness: 'Tambah perniagaan',
        newBusinessTitle: 'Perniagaan baharu',
        businessName: 'Nama perniagaan',
        businessNamePlaceholder: 'Masukkan nama perniagaan',
        createBusiness: 'Cipta',
        businessNameRequired: 'Masukkan nama perniagaan',
        createBusinessSuccess: 'Perniagaan berjaya dicipta'
    },
    network: {
        loginExpired: 'Log masuk telah tamat, sila log masuk semula',
        requestTimeout: 'Permintaan tamat masa, sila semak rangkaian'
    },
    language: {
        label: 'Bahasa',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        searchPlaceholder: 'Cari invois anda',
        addInvoice: 'Tambah invois',
        overdueInvoices: 'Invois tertunggak',
        paidInvoices: 'Invois berbayar',
        unpaidInvoices: 'Invois belum berbayar',
        unsentInvoices: 'Invois belum dihantar',
        columnNumber: 'Nombor',
        columnClient: 'Pelanggan',
        columnStatus: 'Status',
        statusFullyPaid: 'Sepenuhnya dibayar',
        statusPartial: 'Separa',
        statusOverdue: 'Tertunggak',
        statusUnsent: 'Tidak Dihantar',
        statusSent: 'Dihantar',
        statusOpened: 'Dibuka',
        actionRecordPayment: 'Rekod Pembayaran',
        actionMarkAsSent: 'Tanda sebagai Dihantar',
        actionCopy: 'Salin',
        actionDelete: 'Padam',
        copyDialogTitle: 'Salin invois',
        copyTargetType: 'Salin ke',
        copyOptions: 'Pilihan salinan',
        copyClient: 'Salin pelanggan',
        copyItems: 'Salin item',
        copyAttachments: 'Salin lampiran',
        confirmDelete: 'Ini akan memadam invois. Teruskan?',
        copySuccess: 'Invois disalin',
        copyFailed: 'Gagal menyalin',
        deleteSuccess: 'Invois dipadam',
        deleteFailed: 'Gagal memadam',
        recordPaymentDialogTitle: 'Rekod Pembayaran',
        markAsFullyPaid: 'Tanda sebagai sepenuhnya dibayar',
        formAmount: 'Jumlah',
        formDate: 'Tarikh',
        formPaymentMethod: 'Kaedah Pembayaran',
        formNote: 'Nota',
        allYears: 'Semua tahun',
        errorMorePaymentThanBalanceDue: 'Bayaran melebihi baki tertunggak',
        errorAmountMustBeGreaterThanZero: 'Jumlah mesti lebih besar daripada sifar',
        dueDateToday: 'Hari ini',
        dueDateDaysAgo: '{days} hari lalu',
        dueDateInDays: 'dalam {days} hari'
    },
    estimate: {
        pageTitlePurchaseOrders: 'Pesanan Pembelian',
        pageTitleEstimates: 'Anggaran',
        searchPlaceholderPurchaseOrders: 'Cari pesanan pembelian anda',
        searchPlaceholderEstimates: 'Cari anggaran anda',
        addPurchaseOrder: 'Tambah pesanan pembelian',
        addEstimate: 'Tambah anggaran',
        columnNumber: 'Nombor',
        columnClient: 'Pelanggan',
        columnDate: 'Tarikh',
        columnEmail: 'E-mel',
        columnStatus: 'Status',
        columnTotal: 'Jumlah',
        statusUnsent: 'Tidak dihantar',
        statusSent: 'Dihantar',
        actionMarkAsSent: 'Tanda sebagai Dihantar',
        actionCopy: 'Salin',
        actionDelete: 'Padam',
        actionConvertToInvoice: 'Tukar kepada invois',
        copyDialogTitle: 'Salin {document}',
        copyTargetType: 'Salin ke',
        copyOptions: 'Pilihan salinan',
        copyClient: 'Salin pelanggan',
        copyItems: 'Salin item',
        copyAttachments: 'Salin lampiran',
        confirmDelete: 'Ini akan memadam {document}. Teruskan?',
        convertConfirm: 'Tukar {document} ini kepada invois? Tarikh akan ditetapkan ke hari ini.',
        copySuccess: '{document} disalin',
        copyFailed: 'Gagal menyalin',
        convertSuccess: '{document} ditukar kepada invois',
        convertFailed: 'Gagal menukar',
        deleteSuccess: '{document} dipadam',
        deleteFailed: 'Gagal memadam',
        dueDateToday: 'Hari ini',
        dueDateDaysAgo: '{days} hari lalu',
        dueDateInDays: 'dalam {days} hari'
    },
    item: {
        pageTitle: 'Item',
        searchPlaceholder: 'Cari item anda',
        addItem: 'Tambah item',
        columnInventoryCountUnit: 'Kiraan Inventori/Unit'
    },
    client: {
        pageTitle: 'Pelanggan',
        searchPlaceholder: 'Cari pelanggan anda',
        addClient: 'Tambah pelanggan',
        columnClientName: 'Nama Pelanggan',
        columnEmail: 'E-mel',
        columnPhone: 'Telefon',
        columnBalanceDue: 'Baki Tertunggak',
        noNameFallback: 'TIADA NAMA'
    },
    expense: {
        pageTitle: 'Perbelanjaan',
        searchPlaceholder: 'Cari perbelanjaan anda',
        addExpense: 'Tambah perbelanjaan',
        columnDescription: 'Penerangan',
        columnDate: 'Tarikh',
        columnTotal: 'Jumlah'
    },
    report: {
        headerTitle: 'Laporan',
        tabDashboard: 'Papan pemuka',
        tabReportList: 'Senarai laporan',
        export: 'Eksport',
        annualSalesByClient: 'Jualan tahunan mengikut pelanggan',
        totalOutstandingBalance: 'Jumlah baki tertunggak',
        invoicesCountSuffix: 'invois',
        byMonth: 'Mengikut bulan',
        byQuarter: 'Mengikut suku tahun',
        noSalesFound: 'Tiada jualan ditemui',
        filterReportTypes: 'Jenis laporan',
        filterTimePeriod: 'Tempoh masa',
        filterView: 'Paparan',
        optionMonthly: 'Bulanan',
        optionQuarterly: 'Suku tahunan',
        customerAgingTitle: 'Penuaan Pelanggan',
        noDataForDateRange: 'Tiada data untuk julat tarikh ini',
        typeSalesByDate: 'Jualan mengikut Tarikh',
        typeSalesByClient: 'Jualan mengikut Pelanggan',
        typeSalesByItem: 'Jualan mengikut Item',
        typeSalesJournal: 'Jurnal Jualan',
        typePaymentsByDate: 'Bayaran mengikut Tarikh',
        typePaymentsByClient: 'Bayaran mengikut Pelanggan',
        typePaymentsByType: 'Bayaran mengikut Jenis',
        typePaymentsJournal: 'Jurnal Bayaran',
        typeExpenseByCategory: 'Perbelanjaan mengikut Kategori',
        typeExpenseJournal: 'Jurnal Perbelanjaan',
        typeCustomerAging: 'Penuaan Pelanggan',
        allYears: 'Semua tahun',
        allTime: 'Sepanjang masa',
        allSales: 'Semua jualan',
        taxYearSales: 'Jualan tahun cukai {year}',
        firstColumnMonth: 'Bulan',
        firstColumnQuarter: 'Suku tahun',
        columnSubTotal: 'Jumlah Kecil',
        columnTax: 'Cukai',
        columnDiscount: 'Diskaun',
        columnTotal: 'Jumlah',
        columnAmountPaid: 'Jumlah Dibayar',
        columnAmountOwed: 'Jumlah Berhutang',
        columnClient: 'Pelanggan',
        columnItem: 'Item',
        columnUnitType: 'Jenis Unit',
        columnQuantity: 'Kuantiti',
        columnRateAvg: 'Kadar (purata)',
        columnInvoiceDate: 'Tarikh Invois',
        columnInvoiceNo: 'No Invois',
        columnType: 'Jenis',
        columnPaymentDate: 'Tarikh Bayaran',
        columnCategory: 'Kategori',
        columnExpenseDate: 'Tarikh Perbelanjaan',
        columnMerchant: 'Peniaga',
        columnDescription: 'Penerangan',
        columnCurrentDue: 'Tertunggak Semasa',
        column1To30DaysOverdue: '1-30 Hari Tertunggak',
        column31To60DaysOverdue: '31-60 Hari Tertunggak',
        column61To90DaysOverdue: '61-90 Hari Tertunggak',
        column91PlusDaysOverdue: '91+ Hari Tertunggak',
        monthNames: 'Jan, Feb, Mac, Apr, Mei, Jun, Jul, Ogo, Sep, Okt, Nov, Dis',
        totalRowLabel: 'Jumlah'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Tambah',
        invoicePrefix: 'awalan invois',
        tabCreate: 'Cipta',
        tabPreview: 'Pratonton',
        tabSendEmail: 'Hantar E-mel',
        sectionClient: 'Pelanggan',
        addClient: 'Tambah pelanggan',
        dialogClientInfo: 'Maklumat pelanggan',
        basicInformation: 'Maklumat asas',
        labelName: 'Nama',
        labelEmail: 'E-mel',
        labelPhone: 'Telefon',
        billingAddress: 'Alamat bil',
        labelLine1: 'Baris 1',
        labelLine2: 'Baris 2',
        labelLine3: 'Baris 3',
        shippingAddress: 'Alamat penghantaran',
        labelShippingName: 'Nama Penghantaran',
        labelNotes: 'Nota',
        placeholderCreateOrSelect: 'Cipta atau pilih satu...',
        placeholderClientNotes: 'Tambah nota tentang pelanggan. Mereka tidak dapat melihatnya',
        sectionItems: 'Item',
        saveToYourItem: 'Simpan ke item anda',
        stock: 'Stok:',
        placeholderItemCode: 'kod item',
        placeholderQuantity: 'Kuantiti',
        placeholderRate: 'kadar',
        placeholderInputDescription: 'Masukkan penerangan',
        placeholderInputComment: 'Masukkan Komen',
        placeholderAddRecipient: 'Tambah penerima',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'Subjek e-mel',
        placeholderMessage: 'Tulis mesej anda...',
        labelTo: 'Kepada',
        labelSubject: 'Subjek',
        sectionAttachments: 'Lampiran',
        sectionComment: 'Komen',
        addItem: 'Tambah item',
        addPhoto: 'Tambah foto',
        addPayment: 'Tambah bayaran',
        goBack: 'kembali',
        dialogShippingInfo: 'Maklumat penghantaran',
        dialogRecordPayment: 'Rekod Pembayaran',
        dialogJobDetails: 'Butiran kerja',
        labelAmount: 'Jumlah',
        labelShipDate: 'Tarikh penghantaran',
        labelShipVia: 'Hantar melalui',
        labelTrackingNumber: 'Nombor pengesanan',
        labelFob: 'FOB',
        columnDate: 'Tarikh',
        columnType: 'Jenis',
        msgClientEmailError: 'ralat e-mel pelanggan',
        msgAmountGreaterThanZero: 'Jumlah mesti lebih besar daripada sifar',
        msgMorePaymentThanBalance: 'Bayaran melebihi baki tertunggak',
        mailSentSuccessfully: 'E-mel berjaya dihantar',
        cumulativeTaxNotice: 'Web tidak menyokong pengumpulan cukai dalam invois...',
        numberLogicNotice: 'Kami baru-baru ini mengubah logik nombor. Jika nombor anda tidak betul, editnya di sini. Anda juga boleh pergi ke Tetapan > Sesuaikan Invois > Nombor Seterusnya dan tetapkan nombor permulaan yang anda mahu.',
        confirmUnsavedChanges: 'Anda mempunyai perubahan yang belum disimpan. Adakah anda ingin menyimpan atau membuangnya?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Cukai, diskaun dan potongan',
        purchaseOrder: 'Pesanan Pembelian',
        placeholderPurchaseOrderPrefix: 'awalan pesanan pembelian',
        placeholderEstimatePrefix: 'awalan anggaran',
        labelStatus: 'Status',
        statusIssued: 'Dikeluarkan',
        statusApproved: 'Diluluskan',
        statusPending: 'Belum Selesai',
        statusWithdrawn: 'Ditarik Balik',
        tax: 'Cukai'
    },
    createEstimate: {
        pageTitlePrefix: 'Tambah',
        cumulativeTaxNotice: 'Web tidak menyokong pengumpulan cukai dalam anggaran...'
    },
    updateInvoice: {
        pageTitlePrefix: 'Kemas kini',
        deletePrefix: 'Padam',
        confirmDelete: 'Ini akan memadam invois. Teruskan?',
        cumulativeTaxNotice: 'Invois ini mengandungi cukai kumulatif. Web tidak menyokong fungsi ini buat sementara'
    },
    updateEstimate: {
        pageTitlePrefix: 'Kemas kini',
        deletePrefix: 'Padam',
        confirmDelete: 'Ini akan memadam {document}. Teruskan?',
        cumulativeTaxNotice: 'Anggaran ini mengandungi cukai kumulatif. Web tidak menyokong fungsi ini buat sementara'
    },
    createAccount: {
        title: 'Cipta Akaun',
        placeholderEmail: 'e-mel',
        placeholderPassword: 'Kata laluan',
        placeholderCompanyName: 'Nama Syarikat',
        createAccountButton: 'Cipta akaun',
        alreadyHaveAccount: 'Sudah ada akaun?',
        signIn: 'Log masuk',
        validEmail: 'Sila masukkan alamat e-mel yang sah',
        validPassword: 'Kata laluan mesti 6 aksara atau lebih',
        validCompanyName: 'Sila isi nama syarikat anda'
    },
    clientCreate: {
        pageTitle: 'Tambah pelanggan',
        basicInformation: 'Maklumat asas',
        labelName: 'Nama',
        placeholderName: 'Masukkan nama...',
        labelEmail: 'E-mel',
        placeholderEmail: 'Masukkan alamat e-mel...',
        labelPhone: 'Telefon',
        placeholderPhone: 'Masukkan nombor telefon...',
        billingAddress: 'Alamat bil',
        labelLine1: 'Baris 1',
        labelLine2: 'Baris 2',
        labelLine3: 'Baris 3',
        shippingAddress: 'Alamat penghantaran',
        sameAsBilling: 'Sama seperti alamat bil',
        labelShippingName: 'Nama penghantaran',
        labelShippingLine1: 'Baris 1',
        labelShippingLine2: 'Baris 2',
        labelShippingLine3: 'Baris 3',
        labelNotes: 'Nota',
        placeholderNotes: 'Tambah nota tentang pelanggan. Mereka tidak dapat melihatnya',
        validEmail: 'Sila masukkan alamat e-mel yang sah'
    },
    clientUpdate: {
        pageTitle: 'Kemas kini pelanggan',
        confirmDelete: 'Ini akan memadam pelanggan. Teruskan?'
    },
    itemCreate: {
        pageTitle: 'Tambah item',
        itemTitle: 'Item',
        labelCost: 'Kos',
        labelUnit: 'Unit',
        placeholderUnit: 'Unit',
        defaultTaxes: 'Cukai lalai',
        taxOff: 'mati',
        inventoryTitle: 'Inventori',
        currentInventory: 'Inventori semasa',
        adjustInventory: 'Laras inventori',
        placeholderQuantity: 'Kuantiti',
        placeholderDateAndTime: 'Tarikh dan masa',
        placeholderNote: 'Nota',
        addButton: 'Tambah',
        columnDate: 'Tarikh',
        columnQuantity: 'Kuantiti',
        columnNote: 'Nota',
        withholdingTitle: 'Potongan',
        msgInventoryCannotDisable: 'Inventori tidak boleh dilumpuhkan setelah diaktifkan',
        msgDescriptionRequired: 'Penerangan item diperlukan',
        msgQuantityRequired: 'Kuantiti diperlukan',
        msgDateRequired: 'Tarikh dan masa diperlukan'
    },
    itemUpdate: {
        pageTitle: 'Sunting item',
        columnInvoice: 'Invois',
        confirmDelete: 'Ini akan memadam item. Teruskan?'
    },
    createStatement: {
        pageTitle: 'Penyata',
        tabPreview: 'Pratonton',
        tabSendEmail: 'Hantar E-mel'
    },
    setting: {
        taxInfo: 'Maklumat Cukai',
        taxes: 'Cukai',
        taxYearStarts: 'Tahun cukai bermula',
        taxYearStartSubtitle: 'Tetapkan hari pertama tahun kewangan',
        rateLabel: 'Kadar(%)',
        abbreviation: 'Singkatan',
        addTax: 'Tambah cukai',
        month: 'Bulan',
        day: 'Hari',
        monthPlaceholder: 'Bulan',
        dayPlaceholder: 'Hari',
        saveTaxYearStart: 'Simpan',
        deleteDialogTitle: 'Padam',
        confirmDeleteTax: 'Adakah anda pasti memadam cukai ini?',
        deleteConfirm: 'Padam',
        taxInfoDialogTitle: 'Maklumat Cukai',
        taxName: 'Nama Cukai',
        standardRate: 'Kadar standard (%)',
        additionalRate: 'Kadar tambahan',
        deleteRateX: 'X',
        addRate: 'Tambah kadar',
        taxType: 'Jenis cukai',
        exclusive: 'Eksklusif',
        inclusive: 'Inklusif',
        close: 'tutup',
        saveTax: 'Simpan cukai',
        cantOpenDetailMessage: 'Cukai ini mengandungi cukai kumulatif. Web tidak menyokong fungsi ini buat sementara',
        closeButton: 'Tutup',
        rateIsRequired: 'kadar adalah mustahak',
        rateIsRequiredMsg: 'Kadar adalah mustahak',
        monthAndDayRequired: 'Bulan dan hari diperlukan',
        moreRate: ' kadar lagi',
        moreRates: ' kadar lagi'
    },
    companyInfo: {
        title: 'Maklumat Syarikat',
        details: 'Butiran',
        businessName: 'Nama perniagaan',
        businessNamePlaceholder: 'Nama perniagaan',
        name: 'Nama',
        phone: 'Telefon',
        email: 'E-mel',
        businessNumber: 'Nombor Perniagaan',
        taxNo: 'No Cukai N°',
        deleteField: 'padam',
        addNewField: 'Tambah medan baharu',
        address: 'Alamat',
        line1: 'Baris 1',
        line2: 'Baris 2',
        line3: 'Baris 3',
        currency: 'Mata wang',
        currencyLabel: 'Mata wang',
        symbol: 'Simbol',
        placement: 'Penempatan',
        before: 'Sebelum',
        after: 'Selepas',
        thousandSymbol: 'Simbol Ribu',
        decimalSymbol: 'Simbol Perpuluhan',
        decimalPlaces: 'Tempat Perpuluhan',
        example: 'Contoh',
        terms: 'Terma',
        termsLabel: 'Terma',
        termSameDay: 'Hari yang Sama',
        term7Days: '7 Hari',
        term14Days: '14 Hari',
        term21Days: '21 Hari',
        term30Days: '30 Hari',
        term45Days: '45 Hari',
        term60Days: '60 Hari',
        term90Days: '90 Hari',
        term180Days: '180 Hari',
        term365Days: '365 Hari',
        paymentInfo: 'Maklumat Pembayaran',
        displayOnInvoices: 'Paparkan pada invois',
        titlePlaceholder: 'Tajuk',
        jobDetails: 'Butiran Kerja',
        deleteJobDetail: 'padam',
        addNewJobField: 'tambah medan baharu'
    },
    default: {
        title: 'Lalai',
        emailMessage: 'Mesej E-mel',
        enterDescription: 'Masukkan penerangan',
        emailCc: 'E-mel Cc',
        emailBcc: 'E-mel Bcc',
        emailTip: 'Hantar e-mel pada masa yang sama ke alamat di atas.',
        defaultComments: 'Komen Lalai',
        invoice: 'Invois',
        estimate: 'Anggaran',
        purchaseOrder: 'Pesanan Pembelian',
        creditMemo: 'Memo Kredit',
        emailValidError: 'e-mel sah'
    },
    invoiceDesign: {
        template: 'Templat',
        color: 'Warna',
        labels: 'Label',
        labelInvoice: 'Invois',
        labelEstimate: 'Anggaran',
        labelPurchaseOrder: 'Pesanan pembelian',
        labelCreditMemo: 'Memo kredit',
        labelReceipt: 'RESIT',
        labelTermsFormat: 'Format terma',
        labelBillTo: 'Dibil kepada',
        labelFor: 'Untuk',
        labelDate: 'Tarikh',
        labelInvoiceNo: 'No invois',
        labelEstimateNo: 'No anggaran',
        labelPoNo: 'No PO',
        labelCreditMemoNo: 'No memo kredit',
        labelDueDate: 'Tarikh akhir',
        labelTerms: 'Terma',
        labelAmount: 'Jumlah',
        labelCode: 'Kod',
        labelDescription: 'Penerangan',
        labelQuantity: 'Kuantiti',
        labelRate: 'Kadar',
        labelTax: 'Cukai',
        labelSubtotal: 'Jumlah kecil',
        labelBalanceDue: 'Baki tertunggak',
        labelDiscount: 'Diskaun',
        labelNonTaxableItem: 'Item Tidak Dikenakan Cukai',
        labelPaid: 'Dibayar',
        labelShipping: 'Penghantaran',
        labelTotal: 'Jumlah',
        labelIncludes: 'Termasuk',
        labelTotalAmountPaid: 'Jumlah Bayaran Dibayar',
        labelShipDate: 'Tarikh Penghantaran',
        labelShipTo: 'Hantar kepada',
        labelShipVia: 'Hantar melalui',
        labelTrackingNo: 'No pengesanan',
        labelFob: 'F.O.B',
        prefix: 'Awalan',
        prefixInvoice: 'Invois',
        prefixEstimate: 'Anggaran',
        prefixPurchaseOrder: 'Pesanan Pembelian',
        prefixCreditMemo: 'Memo Kredit',
        nextNumber: 'Nombor Seterusnya',
        numberingBeginsAt: 'Penomboran bermula pada',
        nextNumberInvoice: 'Invois',
        nextNumberEstimate: 'Anggaran',
        nextNumberPurchaseOrder: 'Pesanan Pembelian',
        nextNumberCreditMemo: 'Memo Kredit',
        options: 'Pilihan',
        optionTerms: 'Terma',
        optionDueDate: 'Tarikh Akhir',
        optionShippingAddress: 'Alamat penghantaran',
        optionProductCode: 'Kod produk',
        optionQuantityAndRate: 'Kuantiti dan kadar',
        optionTax: 'Cukai',
        optionAmount: 'Jumlah',
        optionNonTaxableItemStar: 'Bintang item tidak dikenakan cukai',
        optionTaxBreakdown: 'Pecahan Cukai',
        optionPaymentHistory: 'Sejarah pembayaran',
        optionStamp: 'Setem',
        optionPageNumber: 'Nombor Halaman',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: 'Terima kasih atas perniagaan anda! Kami berharap anda berpuas hati dengan kerja kami. Sila remit bayaran dalam 15 hari. Soalan? Komen? Hubungi kami di (111)111-1234 atau e-mel kami di example@owner.com, kami gembira untuk menjawab sebarang soalan atau kebimbangan.',
        previewSubtotal: 'Jumlah kecil',
        previewVat: 'VAT 17.00%',
        previewPayment1: 'Bayaran pada Oct 1, 2019',
        previewPayment2: 'Bayaran pada Oct 2, 2019'
    },
    feedback: {
        title: 'Hantar Maklum Balas',
        invalidEmailNoticePrefix: 'Alamat e-mel pada akaun anda tidak sah, jadi kami tidak dapat menghubungi anda. Sila hantar maklum balas anda daripada alamat e-mel yang sah ke',
        invalidEmailNoticeSuffix: 'Jika boleh, sertakan tangkap layar isu tersebut; ia akan membantu kami menyiasat dan menyelesaikannya.',
        replyTip: 'Selepas menghantar, sila semak e-mel anda untuk balasan.',
        content: 'Kandungan',
        enterDescription: 'Masukkan penerangan'
    },
    createExpense: {
        title: 'Tambah Perbelanjaan',
        description: 'Penerangan',
        expenseDescriptionPlaceholder: 'Penerangan perbelanjaan',
        total: 'Jumlah',
        tax: 'Cukai',
        tip: 'Tip',
        expenseDate: 'Tarikh Perbelanjaan',
        merchant: 'Peniaga',
        merchantPlaceholder: 'Masukkan nama peniaga',
        categoryPlaceholder: 'Pilih kategori',
        addNewCategory: 'Tambah kategori baharu',
        deletePhoto: 'Padam',
        addPhoto: 'Tambah foto',
        deleteCategory: 'padam',
        addCategory: 'Tambah kategori'
    },
    updateExpense: {
        title: 'Kemas Kini Perbelanjaan',
        deleteExpense: 'Padam Perbelanjaan',
        confirmDeleteMsg: 'Ini akan memadam perbelanjaan. Teruskan?'
    },
    notFound: {
        oops: 'ALAMAK!',
        notFoundMsg: 'Sepertinya kami tidak dapat mencari halaman yang anda cari.',
        takeMeHome: 'Bawa saya pulang'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Penghantaran Percuma',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Komputer',
        previewItem2: 'Telefon',
        previewItem3: 'Kek hari jadi',
        previewTaxRate: '17%',
        nonTaxableNote: '* Menunjukkan item tidak dikenakan cukai',
        thanksMessage: 'Terima kasih atas perniagaan anda! Kami berharap anda berpuas hati dengan kerja kami. Sila remit bayaran dalam 15 hari. Soalan? Komen? Hubungi kami di (111)111-1234 atau e-mel kami di example@owner.com, kami gembira untuk menjawab sebarang soalan atau kebimbangan.',
        subtotal: 'Jumlah kecil',
        vat: 'VAT 17.00%',
        payment1: 'Bayaran pada Oct 1, 2019',
        payment2: 'Bayaran pada Oct 2, 2019',
        balanceDue: 'Baki Tertunggak'
    }
};
